export const isWeChat = /MicroMessenger/.test(navigator.userAgent)
